const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/companies/$id.finance.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/companies/$id/finance')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});